<div class="container">
    <div class="header">
        <div class="header-content">
            <span style="font-size: 20px;">ESTADISTICAS DE USO</span>
        </div>
    </div>
    <div class="body">
        <div class="body-tab">
            <mat-tab-group class="custom-tab-group" color="warn" (focusChange)="onTabFocusChange($event)">
                <mat-tab  label="Usuarios activos" id="tab-usuarios">
                    <div class="usuarios-activos-grafico">
                        <canvas id="usuarios"></canvas>
                    </div>
                </mat-tab>
                <mat-tab label="Sesiones totales" id="tab-sesiones">
                    <div class="sesiones-totales-grafico">
                        <canvas id="sesiones"></canvas>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>

        <div class="body-options-container">
            <div class="estadisticas-globales">
                <mat-radio-group aria-label="Selecciona una opcción" [(ngModel)]="opcionSeleccionada">
                    <mat-radio-button value="global">Estadísticas globales</mat-radio-button>
                </mat-radio-group>
                <mat-form-field class="fecha-form">
                    <mat-label style="color: #FBB040;">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateGlobal"
                        [rangePicker]="selectedDatePicker">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start">
                        <input matEndDate placeholder="Fecha fin" formControlName="end">
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePicker" style="color: #FBB040;"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePicker></mat-date-range-picker>
                </mat-form-field>
                <mat-checkbox style="margin-top: 6px;" [(ngModel)]="admin">¿Incluir administradores de plataforma?</mat-checkbox>
            </div>

            <!--ESTADÍSTICAS CLIENTE-->
            <div class="estadisticas-cliente">
                <mat-radio-group aria-label="Selecciona una opcción" [(ngModel)]="opcionSeleccionada">
                    <mat-radio-button value="cliente">Estadísticas por cliente</mat-radio-button>
                </mat-radio-group>

                <mat-form-field class="elige">
                    <mat-label>-Elige un cliente-</mat-label>
                    <mat-select [(ngModel)]="selectedClienteCliente" name="modVer">
                      <mat-option *ngFor="let modVer of clientes" [value]="modVer.value">
                        {{modVer.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="fecha-form">
                    <mat-label style="color: #FBB040;">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateCliente"
                        [rangePicker]="selectedDatePickerCliente">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start">
                        <input matEndDate placeholder="Fecha fin" formControlName="end">
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerCliente" style="color: #FBB040;"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePickerCliente></mat-date-range-picker>
                </mat-form-field>
            </div>

            <!--ESTADÍSTICAS USUARIO-->
            <div class="estadisticas-usuario">
                <mat-radio-group aria-label="Selecciona una opcción" [(ngModel)]="opcionSeleccionada">
                    <mat-radio-button value="usuario">Estadísticas de usuario</mat-radio-button>
                </mat-radio-group>

                <mat-form-field class="elige">
                    <mat-label>-Elige un cliente-</mat-label>
                    <mat-select [(ngModel)]="selectedClienteUsuario" name="modVer">
                      <mat-option *ngFor="let modVer of clientes" [value]="modVer.value">
                        {{modVer.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field class="elige">
                    <mat-label>-Elige un usuario-</mat-label>
                    <mat-select [(ngModel)]="selectedUsuario" name="modVer">
                      <mat-option *ngFor="let modVer of usuarios" [value]="modVer.value">
                        {{modVer.name}}
                      </mat-option>
                    </mat-select>
                </mat-form-field>
                
                <mat-form-field class="fecha-form">
                    <mat-label style="color: #FBB040;">Elige una fecha</mat-label>
                    <mat-date-range-input
                        [formGroup]="selectedDateUsuario"
                        [rangePicker]="selectedDatePickerUsuario">
                        <input matStartDate placeholder="Fecha inicio" formControlName="start">
                        <input matEndDate placeholder="Fecha fin" formControlName="end">
                    </mat-date-range-input>
                    <mat-hint>Día/Mes/Año</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="selectedDatePickerUsuario" style="color: #FBB040;"></mat-datepicker-toggle>
                    <mat-date-range-picker #selectedDatePickerUsuario></mat-date-range-picker>
                </mat-form-field>
            </div>
        </div>

        <div class="body-botones" style="width: 80%;">
            <button mat-flat-button class="aplicar-btn" (click)="loadCharts()">Aplicar filtros</button>
        </div>
    </div>
</div>
<div class="footer"></div>
